module.exports = __webpack_public_path__ + "static/media/sweetspicywings.acfeac49.jpg";